var AbstractWS = require("./AbstractWS");

function UpdateConsumerInfoWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.endpoint = ko.observable(null);
  self.method('POST');
  self.name = 'UpdateConsumerInfoWS';

  self.processData = function (data) {
    var errMsg = null;

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data, false);

    if (self.err) {
      var vm = viewModel.parent;
      vm.conlog(self.err);

      if (self.err.rootCauseType == 'AlreadyQueuedException') {
        if (self.isLangUS()) {
          errMsg = self.parent.messagesWS.get('already.queued');
        }
        else {
          errMsg = self.errorMessage();
          if(!errMsg) {
            errMsg = 'The new phone number is already queued.';
          }
        }

        vm.conlog(errMsg);
        vm.errorMessage(errMsg);
        vm.showError(true);
      }
    }
  };

  /**
   * Defines the string to request API services
   *
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = ko.computed(function () {
    return self.endpoint();
  });

  return self;
};

UpdateConsumerInfoWS.prototype = AbstractWS.prototype;
UpdateConsumerInfoWS.prototype.constructor = UpdateConsumerInfoWS;

module.exports = UpdateConsumerInfoWS;
